import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from 'react-router-mobx'
import { BrowserRouter } from 'react-router-dom'
import { ApolloProvider } from 'react-apollo'

import './index.css'
import routerStore from './stores/router'
import client from './apollo-clients/race'
import App from './App'
import * as serviceWorker from './serviceWorker'

ReactDOM.render(
  <Router component={BrowserRouter} routerStore={routerStore}>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </Router>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()



// WEBPACK FOOTER //
// ./src/index.js